module.exports = __webpack_public_path__ + "img/MES6Indice1.502c3f8d.png";